import React from 'react';
import { SHADCN } from '../theme';

// Plein écran — affiché pendant le bootstrap (vérif session) ou un chargement
// majeur. Splash muet : logo seul, pulsation discrète. Suit le thème courant
// via SHADCN.* ; le logo blanc est inversé en mode clair par la règle CSS
// globale `img[src*="logo-white"]` de theme.js.

export default function PageLoader() {
  return (
    <div
      style={{
        background: SHADCN.bg,
        color: SHADCN.fg,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src="/logo-white.png"
        alt="Sonore"
        style={{
          height: 'clamp(24px, 4vw, 32px)',
          width: 'auto',
          animation: 'sk-pulse 2.4s ease-in-out infinite',
        }}
      />
    </div>
  );
}
